// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__u5gg+","logo":"Footer_logo__vN7-C","rights":"Footer_rights__wnw41","socials":"Footer_socials__BkTPo","pulse":"Footer_pulse__EP9CW"};